import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { loadScript, sleep, getDomainPath } from '../tools';
import { ecoType } from '../const';
import RecorderManager from '../record/index';
import setTitle from '../setTitle/index';
import { loadJsUrl } from '../const/loadJsUrl';
/** Config 对象，onReady 函数判断是否SDK加载并鉴权成功 */

export var Config = /*#__PURE__*/function () {
  function Config(options) {
    this.setTitle = setTitle;
    this.log = Config.log;
    // 当前环境是否支持 config 鉴权，由派生类赋值
    this.support = false; // 当前机构的机构ID

    this.orgId = options.orgId || window.localStorage.orgId || ''; // 当前应用ID

    this.agentId = options.agentId;
    this.apiList = options.apiList || [];
    this.urlPath = getDomainPath();
    this.ecoType = ecoType;
    this.configType = null;
  }
  /** 当前环境是否支持 config 鉴权，由派生类赋值 */


  var _proto = Config.prototype;

  _proto.getRecorderManager = function getRecorderManager() {
    return new RecorderManager();
  };

  // 派生类复写，各种环境下的鉴权完毕事件
  // 所有行为调用，必须在onReady之后，需要防止重复ready
  _proto.onReady =
  /*#__PURE__*/
  function () {
    var _onReady = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", true);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function onReady() {
      return _onReady.apply(this, arguments);
    }

    return onReady;
  }() // 打印log信息
  ;

  Config.log = function log() {
    var _console;

    (_console = console).log.apply(_console, arguments);
  } // 微信SDK加载，最多重试3次
  // static async loadSDK(url: string, lives: number = 3) {
  ;

  Config.loadSDK =
  /*#__PURE__*/
  function () {
    var _loadSDK = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(lives) {
      var url, ok;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (lives === void 0) {
                lives = 3;
              }

              url = loadJsUrl[ecoType];
              _context2.next = 4;
              return loadScript(url, true);

            case 4:
              ok = _context2.sent;

              if (!(!ok && lives)) {
                _context2.next = 12;
                break;
              }

              this.log('load sdk fail:', ok, 'lives:', lives, url);
              _context2.next = 9;
              return sleep(50);

            case 9:
              _context2.next = 11;
              return this.loadSDK(lives - 1);

            case 11:
              return _context2.abrupt("return", _context2.sent);

            case 12:
              return _context2.abrupt("return", ok);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function loadSDK(_x) {
      return _loadSDK.apply(this, arguments);
    }

    return loadSDK;
  }();

  _proto.on = /*#__PURE__*/function () {
    var _on = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(protocolName, data) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.onReady();

            case 2:
              _context3.t0 = _context3.sent;

              if (!_context3.t0) {
                _context3.next = 7;
                break;
              }

              _context3.next = 6;
              return this.protocol(protocolName, data);

            case 6:
              _context3.t0 = _context3.sent;

            case 7:
              return _context3.abrupt("return", _context3.t0);

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function on(_x2, _x3) {
      return _on.apply(this, arguments);
    }

    return on;
  }();

  return Config;
}();
export default Config;